import { CommandModel } from "@/app/entities";
import { DashboardHeader, SideImageCard, UiButton } from "@/components";
import { CommandeForm } from "@/components/molecules/commande";
import { useCommande } from "@/composables/commande";
import { useToast } from "@/composables/toast";
import { ArrowLeft } from "lucide-react";
import { useParams, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";

export default function ModificationCommande() {
  const { reference } = useParams<{ reference: string }>();
  const navigate = useNavigate();
  const { getCommandeByReference } = useCommande();
  const [commande, setCommande] = useState<CommandModel | undefined>(undefined);

  useEffect(() => {
    if (!reference) {
      navigate(-1);
      return;
    }
    const theCommand = getCommandeByReference(reference);
    if (!theCommand) {
      useToast("Commande introuvable", {
        variant: "error",
      });
      return;
    }
    setCommande(theCommand);
  }, [reference]);

  return (
    <>
      <DashboardHeader subTitle="Gestion des commandes" />

      <div className="py-4">
        <SideImageCard imgSrc="/assets/images/chris-lee-70l1tDAI6rM-unsplash 1.png">
          <div className="">
            <UiButton
              variant="text"
              onClick={() => navigate(-1)}
              startIcon={<ArrowLeft />}
            >
              Retour
            </UiButton>

            <CommandeForm initialValue={commande} />
          </div>
        </SideImageCard>
      </div>
    </>
  );
}
